<template>
  <div :class="['op--modal-container', {'hide':!show}]" @click="show = false">
    <div class="op--modal">
      <div class="op--modal-content promo-form" @click.stop>
        <div class="heading" id="addPromo">Create Discount Code</div>

        <div class="error-box" v-show="!!errorReturn">{{ errorReturn }}</div>

        <div class="row row-padding">
          <div class="data-field">
            <div class="label">Code</div>
            <input type="text" :class="['input', {'has-error':!!errorMsg.code}]"
              v-model="code" :disabled="loading" @keydown.space="(event) => event.preventDefault()"
              @paste="removeEventSpaces" />
            <span class="error-msg">{{ errorMsg.code }}</span>
          </div>
        </div>

        <div class="row row-padding">
          <div class="data-field">
            <div class="label">Description</div>
            <textarea v-model="desc" :disabled="loading"></textarea>
            <span class="error-msg">{{ errorMsg.desc }}</span>
          </div>
        </div>

        <div class="row row-padding">
          <div class="column small-6 padding-R">
            <div class="data-field">
              <div class="label">Type</div>
              <select v-model="type" :disabled="loading">
                <option value="$">$</option>
                <option value="%">%</option>
              </select>
            </div>
          </div>
          <div class="column small-6 padding-L">
            <div class="data-field">
              <div class="label">Amount</div>
              <input type="text" :disabled="loading" v-model="amount"
               :class="{'input':true, 'has-error':!!errorMsg.amount}" />
              <span class="error-msg">{{ errorMsg.amount }}</span>
            </div>
          </div>
        </div>

        <div class="row row-padding">
          <div class="column small-12 end">
            <div class="data-field input-date">
              <div class="label">Start Date</div>
              <div class="row">
                <div class="column small-5 padding-R">
                  <datepicker :format="calendarFormat" class="datepicker inline"
                    v-on:input="changeDate('startDate')"
                    v-model="startDate" :disabled-picker="loading" :disabled="startDateDisabled"
                    :input-class="{'datepicker-empty':errorMsg.startDate}"
                  ></datepicker>
                  <span class="error-msg">{{ errorMsg.startDate || errorMsg.startDateHour || errorMsg.startDateMinute }}</span>
                </div>
                <div class="column small-3 padding-L">
                  <select v-model="startDateHour" :disabled="loading"
                    :class="{'has-error':!!errorMsg.startDateHour}">
                    <option value="" disabled selected>Hour</option>
                    <option v-for="x in 24" :value="leadingZero(x - 1)" :key="x">{{ leadingZero(x - 1) }}</option>
                  </select>
                </div>
                <div class="column small-1 text-center"><span class="time">:</span></div>
                <div class="column small-3 padding-R">
                  <select v-model="startDateMinute" :disabled="loading"
                    :class="{'has-error':!!errorMsg.startDateMinute}">
                    <option value="" disabled selected>Minute</option>
                    <option v-for="x in 12" :value="leadingZero((x - 1) * 5)" :key="x">{{ leadingZero((x - 1) * 5) }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row row-padding">
          <div class="column small-12 end">
            <div class="data-field input-date">
              <div class="label">End Date</div>
              <div class="row">
                <div class="column small-5 padding-R">
                  <datepicker class="datepicker inline" :format="calendarFormat"
                    v-on:input="changeDate('endDate')"
                    v-model="endDate" :disabled-picker="loading" :disabled="endDateDisabled"
                    :input-class="{'datepicker-empty':errorMsg.expirationDate}"
                  ></datepicker>
                  <span class="error-msg">{{ errorMsg.endDate || errorMsg.endDateHour || errorMsg.endDateMinute }}</span>
                </div>
                <div class="column small-3 padding-L">
                  <select v-model="endDateHour" :disabled="loading"
                    :class="{'has-error':!!errorMsg.endDateHour}">
                    <option value="" disabled selected>Hour</option>
                    <option v-for="x in 24" :value="leadingZero(x - 1)" :key="x">{{ leadingZero(x - 1) }}</option>
                  </select>
                </div>
                <div class="column small-1 text-center"><span class="time">:</span></div>
                <div class="column small-3 padding-R">
                  <select v-model="endDateMinute" :disabled="loading"
                    :class="{'has-error':!!errorMsg.endDateMinute}">
                    <option value="" disabled selected>Minute</option>
                    <option v-for="x in 12" :value="leadingZero((x - 1) * 5)" :key="x">{{ leadingZero((x - 1) * 5) }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row row-padding">
          <div class="column small-4 padding-R">
            <div class="data-field">
              <div class="label">Valid Only for New Users</div>
              <select v-model="newUsers" :disabled="loading">
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>
          <div class="column small-4">
            <div class="data-field">
              <div class="label">Redeemable once per user</div>
              <select v-model="reedemOnce" :disabled="loading">
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>
          <div class="column small-4 padding-L">
            <div class="data-field">
              <div class="label">Number of Codes to Redeem</div>
              <input type="text" :disabled="loading" v-model="maxUse" @keypress="onlyNumber"
               :class="['input', {'has-error':!!errorMsg.maxUse}]" />
              <span class="error-msg">{{ errorMsg.maxUse }}</span>
            </div>
          </div>
        </div>

        <div class="row row-padding">
          <div class="column small-6">
            <div class="data-field">
              <label class="check-field">
                <input type="checkbox" v-model="isWidget" />
                Enable on Widget
              </label>
            </div>
          </div>
          <div class="column small-6">
            <div class="data-field">
              <label class="check-field">
                <input type="checkbox" v-model="isApp" />
                Enable on App
              </label>
            </div>
          </div>
        </div>

        <!-- <div class="row row-padding">
          <div class="column small-6 padding-R">
            <div class="data-field">
              <div class="label">Enabled</div>
              <select v-model="enabled" :disabled="loading">
                <option :value="true">Enabled</option>
                <option :value="false">Disabled</option>
              </select>
            </div>
          </div>
        </div> -->

        <div class="row row-button">
          <div class="column small-12">
            <div class="button cta error small" @click="show = false">Cancel</div>
            <div class="button cta success small" @click="save">Save</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import datepicker from 'vuejs-datepicker'

export default {
  name: 'discount-code-add',
  components: { datepicker },
  props: [ 'isMobile'],
  data () {
    return {
      show: false,
      code: '',
      desc: '',
      type: '$',
      amount: '',
      startDate: '',
      startDateHour: '',
      startDateMinute: '',
      endDate: '',
      endDateHour: '',
      endDateMinute: '',
      enabled: true,
      maxUse: '10',
      newUsers: '1',
      reedemOnce: '1',
      isWidget: 1,
      isApp: 1,
      errorMsg: {
        code: '',
        desc: '',
        amount: '',
        startDate: '',
        startDateHour: '',
        startDateMinute: '',
        endDate: '',
        endDateHour: '',
        endDateMinute: '',
        maxUse: ''
      },
      errorReturn: '',
      today: moment(),
      loading: false
    }
  },
  computed: {
    startDateDisabled () {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(
            this.today.subtract(1, 'months').format('YYYY'),
            this.today.format('MM'),
            this.today.format('DD')
          )
        }
      }

      return {
        to: new Date(
          this.today.format('YYYY'),
          this.today.subtract(1, 'months').format('MM'),
          this.today.format('DD')
        )
      }
    },
    endDateDisabled () {
      let date = this.startDate ? moment(this.startDate).add(1, 'days') : moment()
      if (date.format('MM') === '01') {
        return {
          to: new Date(
            date.subtract(1, 'months').format('YYYY'),
            date.format('MM'),
            date.format('DD')
          )
        }
      }

      return {
        to: new Date(
          date.format('YYYY'),
          date.subtract(1, 'months').format('MM'),
          date.format('DD')
        )
      }
    }
  },
  methods: {
    showModal () { this.show = true },
    calendarFormat (date) { return moment(date).format('MM/DD/YYYY') },
    changeDate (field) {
      this[field] = moment(this[field]).format('MM/DD/YYYY')
    },
    save () {
      let self = this
      if (self.loading) { return }

      if (self.validate()) {
        self.loading = true
        this.$store.commit('global/setLoaderData', { show: true, message: '' })
        let startDate = moment(self.startDate)
        startDate = moment(startDate.format('MM/DD/YYYY ') + self.startDateHour + ':' + self.startDateMinute)
        let endDate = moment(self.endDate)
        endDate = moment(endDate.format('MM/DD/YYYY ') + self.endDateHour + ':' + self.endDateMinute)

        self.$sdk.post('/discountcode', {
          token: self.$store.state.session.sessionToken,
          code: self.code,
          type: self.type,
          amount: self.amount,
          startUTC: startDate.format('X'),
          endUTC: endDate.format('X'),
          enabled: self.enabled,
          description: self.desc,
          maxUse: self.maxUse,
          isWidget: self.isWidget == '1',
          isApp: self.isApp == '1',
          oncePerUser: self.reedemOnce == '1',
          newUsersOnly: self.newUsers == '1'
        }, res => {
          self.loading = false
          self.$store.commit('global/setLoaderData', { show: false, message: '' })
          if (res.error) {
            self.$store.commit('global/setAlertData', {
              show: true,
              message: res.error.message
            })
            return
          }

          self.show = false
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'Successfully created a Discount Code.'
          })
          self.$emit('refresh')
        })
      }
    },
    validate () {
      this.resetErrorMsg()
      let hasError = false

      console.log('~', this.maxUse)
      for (let field in this.errorMsg) {
        if (this[field] === '') {
          this.errorMsg[field] = 'This field cannot be empty.'
          hasError = true
        }
        if (this[field] && field === 'maxUse' && parseInt(this.maxUse) < 1) {
          this.errorMsg[field] = 'Must be atleast 1.'
          hasError = true
        }
      }

      return !hasError
    },
    resetErrorMsg () {
      this.errorMsg = {
        code: '',
        amount: '',
        startDate: '',
        startDateHour: '',
        startDateMinute: '',
        endDate: '',
        endDateHour: '',
        endDateMinute: '',
        maxUse: ''
      }
    },
    clearForm () {
      this.code = ''
      this.type = '$'
      this.amount = ''
      this.startDate = ''
      this.startDateHour = ''
      this.startDateMinute = ''
      this.endDate = ''
      this.endDateHour = ''
      this.endDateMinute = ''
      this.enabled = true
    },
    scrollToTop () {
      let elmnt = document.getElementById('addPromo')
      elmnt.scrollIntoView({behavior: 'smooth', block: 'start'})
    },
    leadingZero (x) { return x < 10 ? '0' + x : x },
    removeEventSpaces (e) {
      e.preventDefault()
      const left    = e.target.value.substring(0, e.target.selectionStart);
      const right   = e.target.value.substring(e.target.selectionEnd, e.target.value.length);
      const pasted  = (e.dataTransfer || e.clipboardData).getData('text').replace(/ /g, '');
      e.target.value = left + pasted + right;
    },
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      if (keyCode < 48 || keyCode > 57)  {
        $event.preventDefault()
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.op--modal {
  display: flex;
  align-items: center!important;
  width: 100%;
  height: 100%;
}
.op--modal-content.center{
  display: table-cell;
  vertical-align: middle;
}

.promo-form{
  background-color: #fff;
  width: 600px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  position: relative;
}

.heading{
  background: #333;
  color: #fff;
  font-weight: 600;
  font-size: 21px;
  padding: 10px 20px;
  margin-bottom: 20px;
}
.clear{ clear:both; }

.data-field{
  position: relative;
  margin-bottom: 10px;
  .label{
    color: #888;
    font-weight: 600;
    font-size: 12px;
    line-height: 130%;
    margin-bottom: 1px;

    &.has-error{ color: #f20d0d; }
    &.underline{
      padding-bottom: 3px;
      margin-bottom: 10px;
      border-bottom: 1px solid #ccc;
    }
    .secondary{
      color: #5390dc;
      display: inline-block;
      margin-left:3px;
    }
  }
  .input{
    margin: 1px 0 0;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #eee; }
  }
  textarea{
    border: 1px solid #ddd;
    width: 100%;
    height: 100px;
    resize: none;
    padding: 10px;
    font-size: 13px;
    color: #555;
    outline: none;
    margin-top: 5px;

    &.has-error{ border-color: #f20d0d; }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
}
select{
  margin-top: 1px;
  border: 1px solid #ddd;
  padding: 10px;
  color: #333;
  height: 45px;
  position: relative;
  font-size:14px;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('/assets/img/dropdown-arrow.png');
  background-repeat: no-repeat;
  background-position: right 50%;
  transition: all .35s ease;

  &.has-error{ border-color: #f20d0d; }
  &:disabled{ background-color: #eee; }
}
.time{
  display: inline-block;
  line-height: 45px;
}
.row-button{
  background: #f6f6f6;
  border-top:1px solid #ddd;
  text-align: center;
  padding: 10px 0;

  .button{
    margin: 0 5px;
    min-width: 150px;
  }
}
.check-field{
  font-size: 14px;
  margin-bottom: 10px;
  display: inline-block;
  color: #888;
  font-weight: 600;

  input {
    width: auto;
    display: inline-block;
    margin-right: 3px;
    vertical-align: -1px;
  }
}

.row{ max-width: 100%; }
.row-padding{ padding: 5px 15px; }
.padding-L{ padding-left: 10px; }
.padding-R{ padding-right: 10px; }
.margin-B{ margin-bottom: 20px; }
.text-center{ text-align: center; }

.error-box{
  margin:0 30px;
  border:1px solid #f34c31;
  color:#f34c31;
  padding: 5px;
  margin-bottom: 15px;
  font-size:14px;
  font-weight:600;
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .padding-L, .padding-R {
    padding: 0;
  }

  .small-5, .small-4, .small-6, .promo-form {
    width: 100%;
  }

  .promo-form {
    height: 100%;
    overflow: auto;
  }
  
  .small-3 {
    width: 45%;
  }
  .small-1 {
    width: 10%;
  }
  .small-5 {
    margin-bottom: 10px;
  }

  .data-field textarea {
    height: 80px;
  }
  .input-date {
    .small-5 {
      width: 45%;
      padding-right: 5%;
    }
    .small-3 {
      width: 25%;
      padding: 0;
      margin: 0;
      float: left;
    }
    .small-1 {
      width: 5%;
    }
  }
  .promo-code {
    width: 50%;
    padding-right: 5%;
  }
  .credit-amount {
    width: 50%;
  }
  .w-50 {
    width: 50%;
    &.padding-r {
      padding-right: 5%;
    }
  }
}

@media screen and (max-width: 430px) {
  .op--modal {
    display: flex;
    align-items: center;
    width: 98%;
    margin: 0 auto;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/DiscountCodes/AddModal.vue